// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3VQkM","head":"ProcedureTableInfo_head__2eEjM"};